import { render, staticRenderFns } from "./RecommendCourse.vue?vue&type=template&id=48bee98c&scoped=true"
import script from "./RecommendCourse.vue?vue&type=script&lang=js"
export * from "./RecommendCourse.vue?vue&type=script&lang=js"
import style0 from "./RecommendCourse.vue?vue&type=style&index=0&id=48bee98c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48bee98c",
  null
  
)

export default component.exports